module.exports = __webpack_public_path__ + "img/499.38636145.png";